<template>
  <label class="switch" :class="classes">
    <input
      class="switch__input"
      type="checkbox"
      :checked.prop="value"
      name="name"
      @click="onClick"
    />
    <i class="switch__thumb" />
    <i class="switch__track" />
  </label>
</template>

<script>
export default {
  name: "CSwitch",
  props: ["value"],
  computed: {
    classes() {
      return [{ "is-checked": !this.value }];
    }
  },
  methods: {
    onClick(e) {
      //this.isChecked = !!e.target.checked;
      this.$emit("input", !!e.target.checked);
    }
  }
};
</script>

<style lang="scss" scoped>
.switch {
  position: relative;

  width: 48px;

  cursor: pointer;
  &__thumb {
    position: absolute;
    left: 0;
    top: calc(50% - 14px);
    z-index: 2;

    width: 28px;
    height: 28px;

    background-color: #fff;
    box-shadow: 0 2.8px 2.8px rgba(0, 0, 0, 0.24), 0 0 2.8px rgba(0, 0, 0, 0.12);
    transition: 200ms ease;
    border-radius: 50%;
  }

  &__track {
    position: absolute;
    left: 0;
    top: calc(50% - 14px);
    width: 48px;
    height: 28px;

    border-radius: 14px;

    background-color: #26cc72;
  }

  &.is-checked &__track {
    background-color: #19a95b;
  }

  &.is-checked &__thumb {
    transform: translateX(20px);
  }
}
</style>
